import { checkingStatuses } from "keys/checkingStatuses"
import { cloneDeep } from "lodash"
import { markingWordsHooks } from "pages/Admin/TranscriptionSystem/MarkingWords"
import { useCallback } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"


const useSetCheckingStatus = () => {
    const dispatch = useDispatch()
    const { assessment } = useSelector(state => state.assessment)
    const { words } = useSelector(state => state.words)

    const setChatMarkupState = markingWordsHooks.useChatMarkupState()

    const setCheckingStatus = useCallback((index) => {
        let nWord = cloneDeep(words[index])
        let { marker_type } = nWord
        let nStatus = ''
        if (!marker_type)
            nStatus = checkingStatuses.confirmed
        else if (marker_type === checkingStatuses.confirmed)
            nStatus = checkingStatuses.recheck
        else if (marker_type === checkingStatuses.recheck) {
            setChatMarkupState(nWord)
            // setChatMarkupState({ ...nWord, index: index })

            nStatus = checkingStatuses.question
        }
        else if (marker_type === checkingStatuses.question)
            nStatus = ''

        nWord.marker_type = nStatus
        dispatch(actions.updateSingleWord({ index: index, word: nWord }))
    }, [words])

    return setCheckingStatus
}

export default useSetCheckingStatus